{
  "PROFILE_SETTINGS": {
    "LINK": "Profielinstellingen",
    "TITLE": "Profielinstellingen",
    "BTN_TEXT": "Profiel bijwerken",
    "DELETE_AVATAR": "Verwijder avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar succesvol verwijderd",
    "AVATAR_DELETE_FAILED": "Er is een fout opgetreden bij het verwijderen van de avatar, probeer het opnieuw",
    "UPDATE_SUCCESS": "Uw profiel is succesvol bijgewerkt",
    "PASSWORD_UPDATE_SUCCESS": "Uw wachtwoord is succesvol gewijzigd",
    "AFTER_EMAIL_CHANGED": "Uw profiel is succesvol bijgewerkt. Log opnieuw in als uw inloggegevens zijn gewijzigd",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Afbeelding voor e-mailhandtekening",
        "HINT": "Wordt gebruikt in e-mailhandtekeningen. {'{{'}email_signature_picture{'}}'} wordt vervangen door de URL van deze afbeelding (geen afbeeldingstag) — gebruik het als afbeeldingsbron (de src van een img-tag) in je handtekening of de handtekening van de inbox. Als deze niet is ingesteld, wordt er niets ingevoegd.",
        "DELETE_SUCCESS": "De afbeelding voor de e-mailhandtekening is succesvol verwijderd",
        "DELETE_FAILED": "Er is een fout opgetreden bij het verwijderen van de afbeelding voor de e-mailhandtekening, probeer het opnieuw"
      },
      "AVATAR": "Profiel afbeelding",
      "ERROR": "Corrigeer formulierfouten",
      "REMOVE_IMAGE": "Verwijderen",
      "UPLOAD_IMAGE": "Afbeelding uploaden",
      "UPDATE_IMAGE": "Afbeelding bijwerken",
      "PROFILE_SECTION": {
        "TITLE": "Profiel",
        "NOTE": "Uw e-mailadres is uw identiteit en wordt gebruikt om in te loggen."
      },
      "SEND_MESSAGE": {
        "TITLE": "Sneltoets om berichten te verzenden",
        "NOTE": "U kunt een sneltoets selecteren (Enter of Cmd/Ctrl+Enter) gebaseerd op uw voorkeur voor schrijven.",
        "UPDATE_SUCCESS": "Uw instellingen zijn met succes bijgewerkt",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Verstuur berichten door op Enter te drukken in plaats van op de verzendknop te klikken."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Verstuur berichten door op Cmd/Ctrl + Enter te drukken in plaats van op de verzendknop te klikken."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Pas het uiterlijk van je dashboard aan.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Default",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Dashboardtaal",
          "NOTE": "Overschrijf de accounttaal voor je eigen dashboard. Laat leeg om de standaardinstelling van het account te gebruiken.",
          "USE_ACCOUNT_DEFAULT": "Standaardinstelling van account gebruiken",
          "API_SUCCESS": "Je dashboardtaal is succesvol bijgewerkt"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Berichttaal",
          "NOTE": "Kies of oorspronkelijke berichten of hun vertalingen worden weergegeven",
          "ORIGINAL": "Origineel",
          "TRANSLATED": "Vertaald"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Plakgedrag",
          "NOTE": "Kies hoe geplakte inhoud moet worden verwerkt bij het opstellen van berichten",
          "UPDATE_SUCCESS": "Je plakinstellingen zijn succesvol bijgewerkt",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Alle opmaak behouden",
              "DESCRIPTION": "Behoud alle opmaak, inclusief tabellen, stijlen en andere HTML-elementen, bij het plakken van inhoud."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Alleen tekst met links",
              "DESCRIPTION": "Zet om naar platte tekst, maar behoud klikbare links bij het plakken van inhoud."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Alleen platte tekst",
              "DESCRIPTION": "Verwijder alle opmaak en zet om naar platte tekst bij het plakken van inhoud."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Hoogte van het antwoordveld",
          "NOTE": "Stel de minimale hoogte van het antwoordveld in als percentage van de schermhoogte. Dit geldt alleen voor e-mailgesprekken.",
          "UPDATE_SUCCESS": "Uw instelling voor de hoogte van het antwoordveld is succesvol bijgewerkt",
          "PERCENT_LABEL": "Hoogte (% van de schermhoogte)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Standaard",
              "DESCRIPTION": "Het antwoordveld begint klein en groeit terwijl u typt."
            },
            "CUSTOM": {
              "HEADING": "Aangepast",
              "DESCRIPTION": "Het antwoordveld heeft altijd minstens het gekozen percentage van de schermhoogte."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Automatisch naar volgend gesprek navigeren",
        "NOTE": "Schakel automatisch over naar het volgende open gesprek nadat het huidige is opgelost",
        "UPDATE_SUCCESS": "Instelling voor automatisch navigeren succesvol bijgewerkt"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Handtekening persoonlijke berichten",
        "DESCRIPTION": "Maak een unieke berichthandtekening die onderaan elke e-mail verschijnt die je verstuurt. Je kunt ook een afbeelding in de tekst opnemen.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Ondertekening van bericht opslaan",
        "API_ERROR": "Kon ondertekening niet opslaan! Probeer het opnieuw",
        "API_SUCCESS": "Ondertekening succesvol opgeslagen",
        "IMAGE_UPLOAD_ERROR": "Kon afbeelding niet uploaden! Probeer het opnieuw",
        "IMAGE_UPLOAD_SUCCESS": "Afbeelding succesvol toegevoegd. Klik op opslaan om de handtekening op te slaan",
        "IMAGE_UPLOAD_SIZE_ERROR": "De grootte van de afbeelding moet kleiner zijn dan {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Bericht Ondertekening",
        "ERROR": "Bericht ondertekening kan niet leeg zijn",
        "PLACEHOLDER": "Voer hier uw persoonlijke bericht handtekening in."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Wachtwoord",
        "NOTE": "Het bijwerken van uw wachtwoord zou uw logins op meerdere apparaten opnieuw instellen.",
        "BTN_TEXT": "Wachtwoord wijzigen"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Toegangs-token",
        "NOTE": "Dit token kan worden gebruikt als u een API gebaseerde integratie bouwt",
        "COPY": "Kopiëren",
        "REGENERATE": "Opnieuw genereren",
        "REGENERATE_SUCCESS": "Toegangstoken succesvol opnieuw gegenereerd. Werk alle integraties bij die het oude token gebruiken.",
        "REGENERATE_CONFIRM_TITLE": "Toegangstoken opnieuw genereren?",
        "REGENERATE_CONFIRM_MESSAGE": "Hierdoor wordt het huidige token ongeldig. Integraties die het oude token gebruiken, stoppen met werken."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome-extensie",
        "NOTE": "Installeer onze Chrome-extensie voor uitgebreide meldingen over inkomende telefoongesprekken.",
        "INSTALL_BUTTON": "Extensie installeren",
        "ALREADY_INSTALLED": "Extensie geïnstalleerd"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Geen",
          "MINE": "Assigned",
          "ALL": "Allemaal",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Geen",
          "ASSIGNED": "Toegewezen gesprekken",
          "ALL_CONVERSATIONS": "Alle gesprekken"
        },
        "DEFAULT_TONE": {
          "TITLE": "Notificatie toon:"
        },
        "CONDITIONS": {
          "TITLE": "Voorwaarden voor notificaties:",
          "CONDITION_ONE": "Stuur alleen audio notificaties als het browservenster niet actief is",
          "CONDITION_TWO": "Verstuur notificaties om de 30 seconden tot alle toegewezen gesprekken zijn gelezen"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Meer lezen"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-mail notificaties",
        "NOTE": "Update hier uw e-mailvoorkeuren",
        "CONVERSATION_ASSIGNMENT": "E-mailberichten verzenden wanneer een gesprek aan mij is toegewezen",
        "CONVERSATION_CREATION": "E-mailberichten verzenden wanneer een nieuw gesprek is gemaakt",
        "CONVERSATION_MENTION": "E-mail notificaties versturen wanneer u in een gesprek wordt genoemd",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "E-mail notificaties verzenden wanneer een nieuw bericht is gemaakt in een toegewezen gesprek",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "E-mail notificaties verzenden wanneer een nieuw bericht is gemaakt in een deelnemend gesprek",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "E-mailadres",
        "PUSH": "Push-melding",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Er is een nieuw bericht in een gesprek zonder beschikbare agent",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Pushmeldingen toestaan terwijl je in gesprek bent",
        "TEST_PUSH": "Test",
        "TESTING": "Testen...",
        "TEST_PUSH_DESCRIPTION": "Verstuur testmeldingen om je configuratie te controleren",
        "TEST_NOTIFICATION_ERROR": "Versturen van testmelding mislukt. Probeer het opnieuw.",
        "TEST_LOCAL_TITLE": "Testmelding (lokaal)",
        "TEST_LOCAL_BODY": "Dit is een lokale browsermelding. Als je dit ziet, werken browsermeldingen!"
      },
      "API": {
        "UPDATE_SUCCESS": "Uw notificatie-instellingen zijn succesvol bijgewerkt",
        "UPDATE_ERROR": "Er is een fout opgetreden tijdens het bijwerken van de voorkeuren, probeer het opnieuw"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Pushberichten",
        "NOTE": "Werk je pushberichtvoorkeuren hier bij",
        "CONVERSATION_ASSIGNMENT": "Stuur pushberichten wanneer een gesprek aan mij is toegewezen",
        "CONVERSATION_CREATION": "Stuur pushberichten wanneer een nieuw gesprek is aangemaakt",
        "CONVERSATION_MENTION": "Send push notifications when you are mentioned in a conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in an assigned conversation",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "Je hebt pushberichten voor deze browser ingeschakeld.",
        "REQUEST_PUSH": "Pushberichten inschakelen",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profiel afbeelding"
      },
      "NAME": {
        "LABEL": "Your full name",
        "ERROR": "Please enter a valid full name",
        "PLACEHOLDER": "Please enter your full name"
      },
      "DISPLAY_NAME": {
        "LABEL": "Display name",
        "ERROR": "Please enter a valid display name",
        "PLACEHOLDER": "Please enter a display name, this would be displayed in conversations"
      },
      "POSITION": {
        "LABEL": "Functie",
        "ERROR": "Voer een geldige functie in",
        "PLACEHOLDER": "Voer je functie in"
      },
      "CUSTOM_LINE": {
        "LABEL": "Aangepaste regel",
        "ERROR": "Voer een geldige aangepaste regel in",
        "PLACEHOLDER": "Voer je aangepaste regel in"
      },
      "AVAILABILITY": {
        "LABEL": "Availability",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Bezig",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "E-mailvoorbeeldformaat in de gesprekslijst",
        "NOTE": "Kies wat wordt weergegeven in de gesprekslijst voor gesprekken vanuit e-mail inboxen",
        "SUBJECT": "Onderwerp",
        "SUBJECT_WITH_NOTE": "Onderwerp en laatste bericht als het een privénotitie is",
        "UPDATE_SUCCESS": "E-mailvoorbeeldinstelling succesvol bijgewerkt"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Sneltoetsen uitschakelen",
        "NOTE": "Schakel alle sneltoetsen in de hele applicatie uit",
        "UPDATE_SUCCESS": "Instelling voor sneltoetsen succesvol bijgewerkt"
      },
      "FOLDER_ORDER": {
        "TITLE": "Volgorde van mappen",
        "NOTE": "Pas de volgorde aan waarin mappen (aangepaste weergaven) in de zijbalk verschijnen. Sleep om de volgorde te wijzigen.",
        "NO_FOLDERS": "Geen aangepaste mappen gevonden. Maak mappen aan om je gesprekken te organiseren."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Configuratie van zijbalk",
        "NOTE": "Pas aan welke secties worden weergegeven in de zijbalk met gesprekken.",
        "SAVE_BUTTON": "Configuratie opslaan",
        "UPDATE_SUCCESS": "Configuratie van zijbalk succesvol bijgewerkt",
        "UPDATE_ERROR": "Er is een fout opgetreden bij het bijwerken van de configuratie van de zijbalk, probeer het opnieuw",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Alle gesprekken",
          "ALL_CONVERSATIONS_DESC": "Toon het menu-item Alle gesprekken in de zijbalk",
          "INBOX": "Inbox",
          "INBOX_DESC": "Toon de hoofdinbox met ongelezen meldingen",
          "CONVERSATION_GROUPS": "Vermeldingen en Onbeheerd",
          "CONVERSATION_GROUPS_DESC": "Toon de gespreksgroepen Vermeldingen en Onbeheerd",
          "FOLDERS": "Mappen",
          "FOLDERS_DESC": "Toon aangepaste weergaven (mappen) voor georganiseerde gesprekken",
          "TEAMS": "Teams",
          "TEAMS_DESC": "Toon gesprekken gefilterd op teamtoewijzing",
          "CHANNELS": "Inboxen",
          "CHANNELS_DESC": "Toon gesprekken gefilterd op inbox",
          "LABELS": "Labels",
          "LABELS_DESC": "Toon gesprekken gefilterd op labels"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Telefooninstellingen",
        "NOTE": "Voer de inloggegevens voor je PBX-systeem in.",
        "USERNAME": "Gebruikersnaam",
        "PASSWORD": "Wachtwoord",
        "SUBMIT": "Opslaan",
        "USERNAME_INVALID": "De gebruikersnaam mag alleen letters, cijfers en . _ - + bevatten — geen spaties en geen e-mailadres.",
        "API": {
          "USERNAME_INVALID": "De gebruikersnaam is geen geldige SIP-gebruikersnaam. Gebruik alleen letters, cijfers en . _ - + — geen spaties en geen e-mailadres.",
          "USERNAME_TAKEN": "Deze gebruikersnaam wordt al gebruikt door een andere agent in dit account."
        }
      },
      "EMAIL": {
        "LABEL": "Uw e-mailadres",
        "ERROR": "Voer een geldig e-mailadres in",
        "PLACEHOLDER": "Voer je e-mailadres in, dit zou worden weergegeven in gesprekken"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Current password",
        "ERROR": "Please enter the current password",
        "PLACEHOLDER": "Voer uw huidige wachtwoord in"
      },
      "PASSWORD": {
        "LABEL": "New password",
        "ERROR": "Voer een wachtwoord in van 6 of meer",
        "PLACEHOLDER": "Voer een nieuw wachtwoord in"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Bevestig nieuw wachtwoord",
        "ERROR": "Bevestig wachtwoord moet overeenkomen met het wachtwoord",
        "PLACEHOLDER": "Please re-enter your new password"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Veranderen",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Meld een bug",
    "SELECTOR_SUBTITLE": "Select an account from the following list",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Meld een bug",
    "DESCRIPTION_LABEL": "Beschrijving van probleem",
    "DESCRIPTION_PLACEHOLDER": "Beschrijf het probleem dat je bent tegengekomen...",
    "SUBMIT": "Melding versturen",
    "SUBMITTING": "Versturen...",
    "CANCEL": "Annuleren",
    "SUCCESS": "Bugmelding succesvol verzonden. Bedankt!",
    "VALIDATION_ERROR": "Beschrijf het probleem voordat je het verstuurt"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dagen proefperiode resterend.",
    "TRAIL_BUTTON": "Nu kopen",
    "DELETED_USER": "Deleted User",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Account Suspended",
      "MESSAGE": "Your account is suspended. Please reach out to the support team for more information."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopiëren",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Code succesvol naar het klembord gekopieerd "
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Show More",
      "SHOW_LESS": "Show Less"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Downloaden",
      "UPLOADING": "Uploaden...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Dit verhaal is niet meer beschikbaar.",
      "RECORDING_UNAVAILABLE": "Deze opname is niet meer beschikbaar.",
      "DELETE_RECORDING": {
        "BUTTON": "Gespreksopname verwijderen",
        "TITLE": "Gespreksopname verwijderen?",
        "DESCRIPTION": "Alle opnames van dit gesprek worden definitief uit het telefoonsysteem verwijderd en kunnen niet worden hersteld. Het transcript en de samenvatting van het gesprek blijven behouden.",
        "CONFIRM": "Verwijderen",
        "SUCCESS": "Gespreksopname verwijderd",
        "ERROR": "De gespreksopname kon niet worden verwijderd. Probeer het opnieuw."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Bevestigen"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Verifiëren...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Postvak toevoegen"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Currently viewing:",
    "SWITCH": "Switch",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Gesprekken",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Alle gesprekken",
    "MENTIONED_CONVERSATIONS": "Vermeldingen",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Unattended",
    "REPORTS": "Rapporten",
    "SETTINGS": "Instellingen",
    "CONTACTS": "Contacten",
    "DATA_ASSISTANT": "Data-assistent",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Startpagina",
    "AGENTS": "Medewerkers",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "WhatsApp templates",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Inboxen",
    "NOTIFICATIONS": "Notifications",
    "CANNED_RESPONSES": "Standaard antwoorden",
    "INTEGRATIONS": "Integraties",
    "PROFILE_SETTINGS": "Profielinstellingen",
    "ACCOUNT_SETTINGS": "Accountinstellingen",
    "APPLICATIONS": "Applicaties",
    "LABELS": "Labelen",
    "CUSTOM_ATTRIBUTES": "Aangepaste attributen",
    "AUTOMATION": "Automation",
    "MACROS": "Macro's",
    "TEAMS": "Teams",
    "BILLING": "Billing",
    "CUSTOM_VIEWS_FOLDER": "Folders",
    "CUSTOM_VIEWS_SEGMENTS": "Segments",
    "ALL_CONTACTS": "All Contacts",
    "TAGGED_WITH": "Tagged with",
    "NEW_LABEL": "New label",
    "NEW_TEAM": "New team",
    "NEW_INBOX": "New inbox",
    "REPORTS_CONVERSATION": "Gesprekken",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campagnes",
    "ONGOING": "Ongoing",
    "ONE_OFF": "One off",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Medewerkers",
    "REPORTS_LABEL": "Labelen",
    "REPORTS_INBOX": "Postvak In",
    "REPORTS_TEAM": "Team",
    "REPORTS_PHONE": "Telefoon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Overzicht",
    "WALLBOARD_QUEUES": "Wachtrijen",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Rapporten",
    "NO_WAITING_CALLERS": "geen wachtende bellers",
    "WAITING_CALLERS": "{count} bellers wachtend",
    "SET_AVAILABILITY_TITLE": "Set yourself as",
    "SET_YOUR_AVAILABILITY": "Set your availability",
    "AVAILABILITY_IMPERSONATING": "Vergrendeld zolang je bent ingelogd als deze gebruiker",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Nieuw gesprek",
    "DRAFT": "Concept",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Overview",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Locales",
      "SETTINGS": "Instellingen",
      "DICTIONARY": "Woordenboek"
    },
    "CHANNELS": "Kanalen",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Read docs"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Geblokkeerde domeinen en contacten",
    "DESCRIPTION": "Lijst met geblokkeerde e-maildomeinen voor dit account.",
    "NO_BLOCKED_DOMAINS": "Geen geblokkeerde domeinen gevonden.",
    "BLOCKED_CONTACTS_BTN": "Geblokkeerde contacten"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Billing",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Current Plan",
      "PLAN_NOTE": "You are currently subscribed to the **{plan}** plan with **{quantity}** licenses",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Manage your subscription",
      "DESCRIPTION": "View your previous invoices, edit your billing details, or cancel your subscription.",
      "BUTTON_TXT": "Go to the billing portal"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Need help?",
      "DESCRIPTION": "Do you face any issues in billing? We are here to help.",
      "BUTTON_TXT": "Chat met ons"
    },
    "NO_BILLING_USER": "Your billing account is being configured. Please refresh the page and try again."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Oeps! We konden geen accounts vinden. Maak een nieuw account aan om verder te gaan.",
    "NEW_ACCOUNT": "New Account",
    "SELECTOR_SUBTITLE": "Create a new account",
    "API": {
      "SUCCESS_MESSAGE": "Account created successfully",
      "EXIST_MESSAGE": "Account already exists",
      "ERROR_MESSAGE": "Kan geen verbinding maken met Woot Server, probeer het later opnieuw"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Bedrijfsnaam",
        "PLACEHOLDER": "Wayne Ondernemingen"
      },
      "SUBMIT": "Bevestigen",
      "CANCEL": "Annuleren"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "Open conversation",
      "RESOLVE_AND_NEXT": "Resolve and move to next",
      "NAVIGATE_DROPDOWN": "Navigate dropdown items",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "ADD_ATTACHMENT": "Add Attachment",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "TOGGLE_SIDEBAR": "Toggle Sidebar",
      "GO_TO_REPORTS_SIDEBAR": "Go to Reports sidebar",
      "MOVE_TO_NEXT_TAB": "Move to next tab in conversation list",
      "GO_TO_SETTINGS": "Go to Settings",
      "SWITCH_TO_PRIVATE_NOTE": "Switch to Private Note",
      "SWITCH_TO_REPLY": "Switch to Reply",
      "TOGGLE_SNOOZE_DROPDOWN": "Toggle snooze dropdown",
      "AI_ASSIST_MENU": "AI-assistentie",
      "AI_ASSIST_GRAMMAR": "Grammatica corrigeren",
      "AI_ASSIST_UNIFY_LANG": "Berichttaal unificeren"
    }
  }
}
